import { COUNTRY_DIVISION_DISPLAY, POSTAL_CODE_DISPLAY, STRING } from 'resources'

import { validatePostalCode } from 'utils/validators'

const defaultPlaceholder = STRING.emDash
const defaultErrorMessage = STRING.protect.profileInfo.edit.error.requiredField

const createField = (label, validate, errorMessage = defaultErrorMessage, type = 'text') => ({
  label,
  placeholder: defaultPlaceholder,
  validate,
  errorMessage,
  type,
})

export const getFieldConfig = (region) => ({
  firstName: createField('First Name:', (value) => value !== ''),
  lastName: createField('Last Name:', (value) => value !== ''),
  birthDate: createField('Birth Date:', (value) => value !== '', defaultErrorMessage, 'date'),
  address: createField('Address:', (value) => value !== ''),
  address2: createField('Apt/Suite Number:', () => true),
  city: createField('City:', (value) => value !== ''),
  state: createField(`${COUNTRY_DIVISION_DISPLAY[region] || 'Province'}:`, (value) => value !== ''),
  zip: createField(
    `${POSTAL_CODE_DISPLAY[region] || 'Postal Code'}:`,
    (value, country) => validatePostalCode(value, country),
    STRING.protect.profileInfo.edit.error.zipInvalid(POSTAL_CODE_DISPLAY[region].toLowerCase() || 'postal code'),
  ),
})

export const OPEN_MODAL_KEYS = {
  ADD_EMAIL_ADDRESS: 'addEmailAddress',
  DELETE_EMAIL_ADDRESS: 'deleteEmailAddress',
}
